import * as Sentry from "@sentry/react";

if (
  import.meta.env.REACT_APP_ENV !== "local" &&
  import.meta.env.REACT_APP_ENV !== "development"
) {
  Sentry.init({
    dsn: import.meta.env.REACT_APP_SENTRY_DSN,
    environment: import.meta.env.REACT_APP_ENV,
    release: import.meta.env.REACT_APP_VERSION,
  });
}

export interface SentryTag {
  label: string;
  value: string;
}

export function sentryErrorLog(err: unknown, tags?: SentryTag[]) {
  if (
    import.meta.env.REACT_APP_ENV === "local" ||
    import.meta.env.REACT_APP_ENV === "development"
  ) {
    return;
  }

  Sentry.captureException(err, {
    tags: Object.fromEntries((tags ?? []).map((tag) => [tag.label, tag.value])),
  });
}
